import _inherits from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Performs logging of the events in TypeORM.
 * This version of logger logs everything into ormlogs.log file.
 */
export var DummyLogger = /*#__PURE__*/function () {
  function DummyLogger() {
    _classCallCheck(this, DummyLogger);
  }
  _createClass(DummyLogger, [{
    key: "logQuery",
    value:
    /**
     * Logs query and parameters used in it.
     */
    function logQuery() {
      throw new Error('This logger is not applicable in a browser context');
    }
    /**
     * Logs query that is failed.
     */
  }, {
    key: "logQueryError",
    value: function logQueryError() {
      throw new Error('This logger is not applicable in a browser context');
    }
    /**
     * Logs query that is slow.
     */
  }, {
    key: "logQuerySlow",
    value: function logQuerySlow() {
      throw new Error('This logger is not applicable in a browser context');
    }
    /**
     * Logs events from the schema build process.
     */
  }, {
    key: "logSchemaBuild",
    value: function logSchemaBuild() {
      throw new Error('This logger is not applicable in a browser context');
    }
    /**
     * Logs events from the migrations run process.
     */
  }, {
    key: "logMigration",
    value: function logMigration() {
      throw new Error('This logger is not applicable in a browser context');
    }
    /**
     * Perform logging using given logger, or by default to the console.
     * Log has its own level and message.
     */
  }, {
    key: "log",
    value: function log() {
      throw new Error('This logger is not applicable in a browser context');
    }
  }]);
  return DummyLogger;
}();
export var FileLogger = /*#__PURE__*/function (_DummyLogger) {
  _inherits(FileLogger, _DummyLogger);
  var _super = _createSuper(FileLogger);
  function FileLogger() {
    _classCallCheck(this, FileLogger);
    return _super.apply(this, arguments);
  }
  return _createClass(FileLogger);
}(DummyLogger);